import { AlertTriangle, Loader2, Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  useDeleteUser,
  useSendVerificationEmail,
  useUserDetails,
} from "@/hooks";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { DialogContent } from "@/components/ui/dialog";
import { DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Dialog } from "@/components/ui/dialog";
import { AlertDescription } from "@/components/ui/alert";
import { AlertTitle } from "@/components/ui/alert";
import { Alert } from "@/components/ui/alert";
import { Separator } from "@/components/ui/separator";
import { Navigate } from "react-router";
//import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const ProfilePage = () => {
  const { data: user, isLoading } = useUserDetails();
  const { mutate: sendEmail } = useSendVerificationEmail();
  const { mutate: deleteUser, isPending } = useDeleteUser();
  // const now = new Date();
  // const start = new Date(now.getFullYear(), now.getMonth() - 3, 1);
  // const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // const { data: pointsBurndown } = useGetPointBurndown({
  //   start: start.toISOString(),
  //   end: end.toISOString(),
  // });

  if (user?.type === "anonymous") {
    return <Navigate to="/inicia-sesion?redirect=perfil" />;
  }
  return (
    <div className="grid gap-3 w-full">
      <div className="flex justify-between items-end gap-6">
        <div className="flex flex-col">
          <h1 className="text-lg font-semibold">Perfil de Usuario</h1>
          <p className="text-xs text-muted-foreground">
            Información de su cuenta
          </p>
        </div>
      </div>
      <Separator />
      
      {/* <div>
        <h3 className="text-md font-medium mb-4">Uso de puntos</h3>
        <div className="h-36">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={pointsBurndown} margin={{ left: -40, right: 5, top: 5, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
              <XAxis 
                dataKey="date"
                tick={{ fontSize: 8 }}
                interval="preserveStartEnd"
                tickCount={5}
                tickFormatter={(value) => {
                  const date = new Date(value);
                  return date.toISOString().split('T')[0].slice(5); // Returns MM-DD format
                }}
              />
              <YAxis 
                tick={{ fontSize: 8 }}
              />
              <Tooltip 
                labelFormatter={(label, payload) => {
                  if (payload && payload[0]) {
                    return `Fecha: ${payload[0].payload.date}`;
                  }
                  return label;
                }}
                formatter={(value) => [value, 'Puntos']}
              />
              <Line 
                type="monotone" 
                dataKey="points" 
                stroke="#3b82f6" 
                strokeWidth={1}
                dot={false}
                activeDot={{ r: 3 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div> */}
      
      <div className="">
        {isLoading ? (
          <div className="flex justify-center items-center h-40">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <form className="gap-6">
            <div className="grid grid-cols-1 gap-4 max-w-[450px]">
              <div className="space-y-2">
                <Label htmlFor="company">Id</Label>
                <Input id="id" value={user?.details?.id || ""} disabled />
              </div>
              <div className="space-y-2">
                <Label htmlFor="name">Nombre</Label>
                <Input
                  id="name"
                  value={user?.details?.fullName || ""}
                  disabled
                />
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-4">
                  <Label htmlFor="email">Correo Electrónico</Label>
                  <Badge
                    variant={user?.type === "verified" || user?.type === "subscribed" ? "success" : "muted"}
                  >
                    {user?.type === "verified" || user?.type === "subscribed" ? "Verificado" : "No verificado"}
                  </Badge>
                </div>
                <div className="flex items-center gap-2">
                  <Input
                    id="email"
                    type="email"
                    value={user?.details?.email || ""}
                    disabled
                  />
                  {user?.type === "unverified" ? (
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => sendEmail()}
                      type="button"
                    >
                      <Mail className="h-4 w-4" /> Verificar
                    </Button>
                  ) : null}
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="createdAt">Fecha de Registro</Label>
                <Input
                  id="createdAt"
                  value={
                    user?.details?.createdAt
                      ? `${new Date(
                          user.details.createdAt
                        ).toLocaleString()} UTC`
                      : ""
                  }
                  disabled
                />
              </div>
              <Alert className="border-destructive bg-destructive/5 w-full text-destructive">
                <AlertTriangle className="size-4 text-destructive" />
                <AlertTitle>Peligro</AlertTitle>
                <AlertDescription className="grid w-full">
                  <p>
                    Esta acción eliminará su cuenta, todos sus datos y sus
                    puntos de forma permanente.
                  </p>
                  <div className="flex justify-end w-full">
                    <Dialog>
                      <DialogTrigger asChild>
                        <Button variant="destructive">Eliminar cuenta</Button>
                      </DialogTrigger>
                      <DialogContent>
                        <DialogTitle>Peligro</DialogTitle>
                        <DialogDescription>
                          Al eliminar su cuenta, todos sus datos y puntos serán
                          eliminados. Esta acción no se puede deshacer.
                        </DialogDescription>
                        <DialogFooter>
                          <Button
                            variant="destructive"
                            onClick={() => {
                              deleteUser();
                            }}
                            disabled={isPending}
                          >
                            {isPending ? (
                              <>
                                <Loader2 className="size-4 animate-spin" />
                                Eliminando...
                              </>
                            ) : (
                              "Eliminar cuenta"
                            )}
                          </Button>
                        </DialogFooter>
                      </DialogContent>
                    </Dialog>
                  </div>
                </AlertDescription>
              </Alert>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
